import { useRouter } from "next/router";

import {
  NonAuthBody,
  NonAuthBodyElement,
  NonAuthBodyElementIcon,
  NonAuthBodyElementText,
  NonAuthFooter,
  NonAuthHeader,
  Subtitle,
  Title,
  InfoTitle,
  InfoSubtitle,
  Container,
} from "./styles";

import { trackAction } from "~/analytics";
import { Button } from "~/components/Button";
import useCurrentViewer from "~/hooks/useCurrentViewer";

interface Props {
  did: string;
  vaspName: string;
}

export default function NonAuthenticatedUserBox({ did, vaspName }: Props) {
  const { viewer } = useCurrentViewer();
  const hasUserOnSession = viewer.did !== "noUser";

  const router = useRouter();

  const handleJoinToday = async () => {
    router.push(`/auth?redirect=/dashboard/companies/${did}`);
    trackAction("visitor-clicked-join-for-free", { group_vasp: did });
  };

  return (
    <Container>
      <NonAuthHeader>
        <Title>
          {"Join Notabene VASP network to see " + vaspName + "’s "}
          <span style={{ color: "#48E231" }}>full profile</span>
        </Title>
        <Subtitle>
          {
            "Get access to the information and tools to streamline your Travel Rule compliance regardless of which protocols you and your counterparties use."
          }
        </Subtitle>
      </NonAuthHeader>
      <NonAuthBody>
        <NonAuthBodyElement>
          <NonAuthBodyElementIcon src="/assets/dataProtection.png" />
          <NonAuthBodyElementText>
            <InfoTitle>{"Comprehensive VASP data"}</InfoTitle>
            <InfoSubtitle>Access over 500 crypto companies incorporation and regulatory information</InfoSubtitle>
          </NonAuthBodyElementText>
        </NonAuthBodyElement>
        <NonAuthBodyElement>
          <NonAuthBodyElementIcon src="/assets/travelRule.png" />
          <NonAuthBodyElementText>
            <InfoTitle>{"VASPs Travel Rule status"}</InfoTitle>
            <InfoSubtitle>Monitor which of your counterparties comply with the Travel Rule</InfoSubtitle>
          </NonAuthBodyElementText>
        </NonAuthBodyElement>
        <NonAuthBodyElement>
          <NonAuthBodyElementIcon src="/assets/dashboard.png" />
          <NonAuthBodyElementText>
            <InfoTitle>{"Data transfers with any VASP"}</InfoTitle>
            <InfoSubtitle>Send and receive* Travel Rule data transfers from/to any of your counterparties</InfoSubtitle>
          </NonAuthBodyElementText>
        </NonAuthBodyElement>
      </NonAuthBody>
      <NonAuthFooter>
        <Button kind="success" onClick={handleJoinToday}>
          {hasUserOnSession ? "GO TO DASHBOARD" : "JOIN FOR FREE TODAY"}
        </Button>
      </NonAuthFooter>
    </Container>
  );
}
